var GetWebsiteLocationByPartialMatch = (function () {
    'use strict';

    return (function () {

        var _initialized = false, _firstChars = '', _firstCharAlternatives = [], _websiteLocations, _resultCount = 0, _startNodeId = 0, _compiledTemplate = null, _templateId = '', _inPageElementId = '', _currentItem = 0, _Down = 40, _Up = 38, _Escape = 27, _Enter = 13, _vertical, _flightClassPreference = '', _instanceClientId = '';

        /* Public function */
        function search(evt, searchText, vertical) {

            evt = evt || window.event;

            _vertical = vertical.substring(vertical.lastIndexOf(".") + 1, vertical.length);

            if (evt && (evt.keyCode === _Down || evt.keyCode === _Up || evt.keyCode === _Enter || evt.keyCode === _Escape)) {
                //USER IS NAVIGATING THE RESULTS. CHECK FOR evt AS IT WON'T EXIST ON PAGE LOAD RE-SEARCH
                if (evt.keyCode === _Escape) {
                    reset();
                } else {
                    navigateList(evt.keyCode);
                }
            } else {
                //PERFORMING/FILTERING SEARCH
                if (searchText.length >= 3) {
                    if (searchText.substring(0, 3).toUpperCase() !== _firstChars.substring(0, 3).toUpperCase()) {
                        _firstChars = searchText.toUpperCase();

                        //BUILD UP A LIST OF ALTERNATIVE SEARCHES BASED ON _firstChars. ONLY DO THIS ONCE.
                        switch (_firstChars.substring(0, 3).toUpperCase()) {
                            case 'SAI':
                                _firstCharAlternatives = ['SAI', 'ST ', 'ST.', 'SAINT'];
                                break;
                            case 'ST ':
                                _firstCharAlternatives = ['ST ', 'ST.', 'SAINT'];
                                break;
                            case 'ST.':
                                _firstCharAlternatives = ['ST ', 'ST.', 'SAINT'];
                                break;
                        }

                        if (_startNodeId > 0 && _templateId && _inPageElementId) {
                            _initialized = true;
                            getWebLocationsJson();
                        }
                    } else {
                        _firstChars = searchText.toUpperCase();
                        bind(filter(_websiteLocations));
                    }
                } else {
                    reset();
                }
            }

        }

        function getWebLocationsJson() {

            var url;

            if (_compiledTemplate === null) {
                _compiledTemplate = Handlebars.compile(jQuery('#' + _templateId).html());
            }

            url = [
                    '/utility/getwebsitelocationsbypartialmatch.aspx?startnodeid=',
                    _startNodeId,
                    '&firstcharacters=',
                     _firstChars,
                     '&vertical=',
                     _vertical,
                     '&flightclasspreference=',
                     _flightClassPreference,
                     '&instanceclientid=',
                     _instanceClientId
            ].join('');

            jQuery.ajax({
                url: url,
                cache: false,
                success: function (websiteLocations) {
                    if (websiteLocations) {
                        //CACHE DATA
                        _websiteLocations = websiteLocations;
                        //FILTER RESULTS EVEN IF IT'S NOT NECESSARY AS THIS SETS Handlebars $index/$count VALUES
                        bind(filter(_websiteLocations));
                        LotusGroup.DOM.el(_inPageElementId).style.display = 'block';
                    }
                },
                error: function (feedback) {
                    return;
                }
            });

        }

        function filter(websiteLocations) {

            var filteredArray, path, searchString, len, firstCharAlternativesLen;

            filteredArray = [];

            if (websiteLocations !== null && websiteLocations.Location && websiteLocations.Location.length > 0) {
                filteredArray = websiteLocations.Location.filter(
                //THIS FUNCTION POPULATES THE filteredArray WITH ONLY THOSE LOCATIONS THAT MATCH THE REQUIREMENTS
                    function (location) {
                        if (_firstChars.length >= 3) {
                            len = _firstChars.length;
                            //CLEAN STRINGS AND AMMEND LENGTH OF len ACCORDINGLY
                            path = location.DisplayPath.replace(/,/g, '').toUpperCase();
                            searchString = _firstChars.replace(/,/g, '').toUpperCase();
                            if (_firstChars.indexOf(',') > -1) {
                                len = searchString.length;
                            }
                            if (path.substr(0, len) === searchString || path.substr(0, len + 4) === 'THE ' + searchString) {
                                //JUST CHARACTER MATCH THE FIRST 3 CHARACTERS OF THE AIRPORT NAME
                                return location;
                            } else if (_firstChars.length === 3 || _firstCharAlternatives.length > 0) {
                                firstCharAlternativesLen = _firstCharAlternatives.length;
                                for (var i = 0; i < firstCharAlternativesLen; i++) {
                                    if (path.substr(0, 3) === _firstCharAlternatives[i]) {
                                        //CONTINUE MATCHING ONLY THE FIRST 3 CHARACTERS OR WE LOSE 'St Lucia' WHEN TYPING 'SAIN'
                                        return location;
                                    }
                                }
                            }
                        }
                    }
                );
                _resultCount = websiteLocations.Location.length;
            } else {
                _resultCount = 0;
            }

            return { 'Location': filteredArray };

        }

        function bind(websiteLocations, append) {

            if (!append) {
                //GENERALLY ITEMS SHOULD COMPLETELY REGENERATE THE LIST. SET TO TRUE TO APPEND ITEMS.
                LotusGroup.DOM.el(_inPageElementId).innerHTML = '';
            }
            LotusGroup.DOM.el(_inPageElementId).innerHTML += _compiledTemplate(websiteLocations);
            LotusGroup.DOM.el(_inPageElementId).style.display = 'block';

        }

        function navigateList(keyCode) {

            var listItems, listLen, childAnchor, childEm, currLi;

            if (LotusGroup.DOM.el(_inPageElementId)) {
                listItems = LotusGroup.DOM.el(_inPageElementId).getElementsByTagName('li');

                listLen = listItems.length;

                if (keyCode === _Down && _currentItem < listLen) {
                    _currentItem += 1;
                    if (_currentItem > 2) {
                        LotusGroup.DOM.el(_inPageElementId).scrollTop = parseInt(LotusGroup.DOM.el(_inPageElementId).scrollTop, 10) + 25;
                    }
                } else if (keyCode === _Up && _currentItem > 1) {
                    _currentItem -= 1;
                    if (_currentItem < (listLen - 2)) {
                        LotusGroup.DOM.el(_inPageElementId).scrollTop = parseInt(LotusGroup.DOM.el(_inPageElementId).scrollTop, 10) - 25;
                    }
                } else if (keyCode === _Enter && _currentItem > 0) {
                    window.location = LotusGroup.DOM.el(_instanceClientId + '_liweblocid_' + _currentItem).getElementsByTagName('a')[0].href;
                }

                //UNHIGHLIGHT ALL LIST ITEMS
                for (var i = 0; i < listLen; i++) {
                    listItems[i].removeAttribute('className');
                    listItems[i].removeAttribute('class');
                }

                //HIGHLIGHT RELEVENT LIST ITEM
                currLi = LotusGroup.DOM.el(_instanceClientId + '_liweblocid_' + _currentItem);
                if (currLi) {
                    currLi.className = 'selecteditem';
                    currLi.setAttribute('class', 'selecteditem');
                }
            }

        }

        /* Public function */
        function reset() {

            //CLEAR DOWN & HIDE THE INPAGE HOLDER
            LotusGroup.DOM.el(_inPageElementId).innerHTML = '';
            LotusGroup.DOM.el(_inPageElementId).style.display = 'none';
            _currentItem = 0;
            _websiteLocations = [];
            _firstChars = '';
            _resultCount = 0;
        }

        /* Public Read Only Property */
        function initialized() {
            return _initialized;
        }

        /* Public Read Only Property */
        function startNodeId() {
            return _startNodeId;
        }

        /* Public Read Only Property */
        function resultCount() {
            return _resultCount;
        }

        /* Public Write Only Property */
        function setInstanceClientId(a) {
            /// <summary>
            ///     Setter for the HTML ID of this instance of the WebLocationSearch control
            /// </summary>
            /// <param name="a" type="String">
            ///     Serverside Me.ClientId of WebLocationSearch control.
            /// </param>
            /// <returns type="" />
            _instanceClientId = a;
        }

        /* Public Write Only Property */
        function setTemplateId(a) {
            /// <summary>
            ///     Setter for the HTML ID of the Handlebars template
            /// </summary>
            /// <param name="a" type="String">
            ///     HTML ID of the Handlebars template.
            /// </param>
            /// <returns type="" />
            _templateId = a;
        }

        /* Public Write Only Property */
        function setInPageElementId(a) {
            /// <summary>
            ///     Setter for the HTML ID of the in page element to be populated with the template.
            ///     This should be the natural parent element i.e. UL of an LI or TABLE of an TR
            /// </summary>
            /// <param name="a" type="String">
            ///     HTML ID of the in page element.
            /// </param>
            /// <returns type="" />
            _inPageElementId = a;
        }

        /* Public Write Only Property */
        function setStartNodeId(a) {
            /// <summary>
            ///     Setter for the highest level WebsiteLocationNode beneath which child locations will be returned.
            /// </summary>
            /// <param name="a" type="Integer">
            ///     WebsiteLocationNode.
            /// </param>
            /// <returns type="" />
            _startNodeId = a;
        }

        /* Public Write Only Property */
        function setVertical(a) {
            _vertical = a;
        }

        /* Public Write Only Property */
        function setFlightClassPreference(a) {
            _flightClassPreference = a;
        }

        //EXPOSE PUBLIC METHODS & PROPERTIES
        return {
            initialized: initialized,
            startNodeId: startNodeId,
            resultCount: resultCount,
            search: search,
            reset: reset,
            setInstanceClientId: setInstanceClientId,
            setTemplateId: setTemplateId,
            setInPageElementId: setInPageElementId,
            setStartNodeId: setStartNodeId,
            setVertical: setVertical,
            setFlightClassPreference: setFlightClassPreference
        };

    }());

}());

function prepareWebsiteLocationByPartialMatchSearch(startNodeId, templateId, inPageElementId, webLocSearchInputId, webLocSearchUlId, flightClassPreference) {
    'use strict';

    if (GetWebsiteLocationByPartialMatch) {
        if (!GetWebsiteLocationByPartialMatch.initialized() || GetWebsiteLocationByPartialMatch.startNodeId() !== startNodeId) {
            GetWebsiteLocationByPartialMatch.setStartNodeId(startNodeId);
            GetWebsiteLocationByPartialMatch.setTemplateId(templateId);
            GetWebsiteLocationByPartialMatch.setInPageElementId(inPageElementId);
            GetWebsiteLocationByPartialMatch.setInstanceClientId(inPageElementId.split('_')[0]);
            GetWebsiteLocationByPartialMatch.setFlightClassPreference(flightClassPreference);
            GetWebsiteLocationByPartialMatch.reset();
        }
        if (LotusGroup.DOM.el(webLocSearchInputId).getAttribute('data-placeholder').toUpperCase() === LotusGroup.DOM.el(webLocSearchInputId).value.toUpperCase()) {
            LotusGroup.DOM.el(webLocSearchInputId).value = '';
        }
        if (GetWebsiteLocationByPartialMatch.initialized() && GetWebsiteLocationByPartialMatch.resultCount() > 0) {
            LotusGroup.DOM.el(webLocSearchUlId).style.display = 'block';
        }
        if (LotusGroup.DOM.el('submenu_' + startNodeId)) {
            LotusGroup.DOM.el('submenu_' + startNodeId).style.display = 'block';
        }
    }
}